// extracted by mini-css-extract-plugin
module.exports = {"container":"EditorialPageBreadcrumbs_container__l4F8j"};